import { withInterest } from '../price.text';
export const returnInstallmentInfo = ({
  installment,
  minimumInstallment
}) => {
  const installmentPrice = installment == null ? void 0 : installment.totalAmount;
  const hasInstallment = !!(installment != null && installment.amount && (installment == null ? void 0 : installment.quantity) > minimumInstallment && installment != null && installment.totalAmount);
  const isInstallmentWithoutInterest = (installment == null ? void 0 : installment.paymentMethodDescription) !== withInterest;
  return {
    hasInstallment,
    installmentPrice,
    isInstallmentWithoutInterest
  };
};
export const returnPriceInfo = ({
  finalPrice,
  hideOriginalPrice,
  installmentPrice,
  isInstallmentWithoutInterest,
  price
}) => {
  const isDifferentFinalPrice = parseFloat(price) !== parseFloat(installmentPrice) && parseFloat(price) !== parseFloat(finalPrice);
  const showOriginalPrice = isDifferentFinalPrice && isInstallmentWithoutInterest && !hideOriginalPrice;
  return {
    showOriginalPrice
  };
};
export const returnDiscountInfo = ({
  finalPrice,
  installmentPrice,
  showDiscount,
  showDiscountOnlyCashInfo,
  showInCashInfo
}) => {
  const isFinalPriceLower = parseFloat(finalPrice) < parseFloat(installmentPrice);
  const isInstallmentPriceAbsent = !installmentPrice;
  const showDiscountValue = showInCashInfo && showDiscount && (!showDiscountOnlyCashInfo || isInstallmentPriceAbsent || isFinalPriceLower);
  return {
    showDiscountValue
  };
};